<template>
    <div style="margin: 10px">
        <el-table id="xmtzTable" v-loading="loading" :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; overflow: auto" :max-height="maxHeight" @selection-change="selectedRowsChange">
            <!-- 主表列 -->
            <el-table-column label="项目立项信息" align="center">
                <!-- <el-table-column fixed type="selection" width="50" align="center" :show-overflow-tooltip="true" /> -->
                <el-table-column fixed type="index" label="序号" width="50" align="center" />
                <el-table-column v-for="prop in mainColumns" :key="prop.label" show-overflow-tooltip align="center" :prop="prop.prop" :label="prop.label" :width="prop.width" />
            </el-table-column>
            <!-- 子表列 -->
            <el-table-column label="采购公告信息" align="center">
                <el-table-column v-for="prop in subColumns1" :key="prop.label" show-overflow-tooltip align="center" :prop="prop.prop" :label="prop.label" :width="prop.width" />
            </el-table-column>
            <el-table-column label="结果公告信息" align="center">
                <el-table-column v-for="prop in subColumns2" :key="prop.label" show-overflow-tooltip align="center" :prop="prop.prop" :label="prop.label" :width="prop.width" />
            </el-table-column>
            <el-table-column label="代理合同信息" align="center">
                <el-table-column v-for="prop in subColumns3" :key="prop.label" show-overflow-tooltip align="center" :prop="prop.prop" :label="prop.label" :width="prop.width" />
            </el-table-column>
            <el-table-column v-for="prop in subColumns4" :key="prop.label" show-overflow-tooltip align="center" :prop="prop.prop" :label="prop.label" :width="prop.width" />
            <el-table-column prop="status" label="操作" align="center" :show-overflow-tooltip="true" width="150" fixed="right" :resizable="false">
                <template slot="header" slot-scope="scope">
                    <el-button v-table-toxls="xmtzTable" file-name="招标项目台账">导出XLS</el-button>
                </template>
                <template slot-scope="scope">
                    <el-button size="small" :disabled="scope.row.status == 8" @click="changeStatus(scope.row)">归档</el-button>
                    <el-button @click="exportData(scope.row)">导出</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination style="margin-top: 10px" align="right" prev-text="上一页" next-text="下一页" :current-page="params.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            maxHeight: document.body.clientHeight - 250,
            loading: false,
            total: 0,
            params: {
                pageSize: 10,
                pageNum: 1,
                searchAndOr: ''
            },
            // 主表列（需要合并）
            mainColumns: [
                { label: '项目名称', prop: 'flSubject', width: 250 },
                { label: '公司统一编号', prop: 'projectCode', width: 180 },
                { label: '其他编号（如有）', prop: 'zbXmbh', width: 150 },
                { label: '组织方式', prop: 'zbWay', width: 120 },
                { label: '标的类型', prop: 'zbType', width: 120 },
                { label: '预算金额', prop: 'zbAmount', width: 120 },
                { label: '资金来源及比例', prop: 'zbFund', width: 150 },
                { label: '业主名称', prop: 'projectUnit', width: 120 },
                { label: '业主负责人', prop: 'projectFzr', width: 120 },
                { label: '业主负责人电话', prop: 'projectFzrPhone', width: 150 },
                { label: '总公司/分公司', prop: 'fgsName', width: 150 }
            ],
            colSpan: ['flSubject', 'projectCode', 'zbXmbh', 'zbWay', 'zbType', 'zbAmount', 'zbFund', 'projectUnit', 'projectFzr', 'projectFzrPhone', 'fgsName', 'cgPublicDate', 'bidPackageCount', 'webSite', 'contactPerson', 'jgPublicDate', 'ggType', 'zzbAmount', 'agentAmount', 'contractDate', 'contractFzr', 'chargingStandard', 'status'],
            // 子表列（不合并）
            subColumns1: [
                { label: '发布日期', prop: 'cgPublicDate', width: 120 },
                { label: '标包数量', prop: 'bidPackageCount', width: 120 },
                { label: '标包号', prop: 'bidPackageCode', width: 120 },
                { label: '文件售价', prop: 'filePrice', width: 120 },
                { label: '开标日期', prop: 'openBidDate', width: 120 },
                { label: '发布网站', prop: 'webSite', width: 150 },
                { label: '公告联系人', prop: 'contactPerson', width: 120 }
            ],
            subColumns2: [
                { label: '发布日期', prop: 'jgPublicDate', width: 120 },
                { label: '公告类型', prop: 'ggType', width: 120 },
                { label: '总中标/成交金额', prop: 'zzbAmount', width: 130 },
                { label: '总代理费金额', prop: 'agentAmount', width: 120 },
                { label: '标包号', prop: 'section', width: 120 },
                { label: '标包文件获取人数', prop: 'fileGetCount', width: 130 },
                { label: '标包投标/响应人数', prop: 'responseCount', width: 140 },
                { label: '标包中标人名称', prop: 'supplier', width: 120 },
                { label: '标包中标/成交金额', prop: 'jgZbAmount', width: 140 },
                { label: '标包代理费金额', prop: 'jgAgentAmount', width: 120 }
            ],
            subColumns3: [
                { label: '签订日期', prop: 'contractDate', width: 120 },
                { label: '项目经理', prop: 'contractFzr', width: 120 },
                { label: '收费标准', prop: 'chargingStandard', width: 120 }
            ],
            subColumns4: [{ label: '中标/成交通知书日期', prop: 'notificationDate', width: 120 }],
            tableData: [],
            rowsSelected: [],
            searchText: '',
            flatTableData: [],
            spanArr: [],
            serialNumber: 0
        }
    },
    computed: {},
    created() {
        this.$bus.on('searchListData', this.handleSearch)
        this.$bus.on('setAdvSearchMap', this.setAdvSearchMap)
        this.getListData()
        this.hideBtnByBreadcrumbText()
    },
    beforeDestroy() {
        this.$bus.off('setAdvSearchMap', this.setAdvSearchMap)
        this.hideBtnByBreadcrumbText2()
    },
    mounted() {
        //this.$bus.emit('showNavSearch', false)
    },
    methods: {
        hideBtnByBreadcrumbText() {
            // 1. 获取面包屑目标元素
            const breadcrumbEl = document.querySelector('.no-redirect')
            // 2. 获取需要隐藏的按钮元素
            const advancedBtn = document.querySelector('.advanced-btn')

            if (!breadcrumbEl || !advancedBtn) return // 元素不存在则终止

            // 3. 获取文本并去除首尾空格（避免空格导致匹配失败）
            const breadcrumbText = breadcrumbEl.innerText.trim()

            // 4. 精准匹配文本为“测试”时隐藏按钮
            advancedBtn.classList.add('hide-advanced-btn')
            // if (breadcrumbText === '台账与归档') {
            //     // advancedBtn.style.display = 'none !important'
            //     // 兼容优先级：若行内样式不生效，添加类名（推荐）
            //     advancedBtn.classList.add('hide-advanced-btn')
            // } else {
            //     // 文本不是“测试”时恢复显示
            //     advancedBtn.style.display = ''
            //     advancedBtn.classList.remove('hide-advanced-btn')
            // }
        },
        hideBtnByBreadcrumbText2() {
            // 1. 获取面包屑目标元素
            const breadcrumbEl = document.querySelector('.no-redirect')
            // 2. 获取需要隐藏的按钮元素
            const advancedBtn = document.querySelector('.advanced-btn')

            if (!breadcrumbEl || !advancedBtn) return // 元素不存在则终止

            // 3. 获取文本并去除首尾空格（避免空格导致匹配失败）
            const breadcrumbText = breadcrumbEl.innerText.trim()

            // 4. 精准匹配文本为“测试”时隐藏按钮
            advancedBtn.classList.remove('hide-advanced-btn')
        },
        handleSearch(searchText, searchAndOr, mode) {
            this.searchText = searchText
            this.getListData()
        },
        selectedRowsChange(row) {
            this.rowsSelected = row
        },
        getStatus(status) {
            if (status === '8') {
                return '已归档'
            } else {
                return '未归档'
            }
        },
        handleSizeChange(val) {
            this.params.pageNum = 1
            this.params.pageSize = val
            this.getListData()
        },
        handleCurrentChange(val) {
            this.params.pageNum = val
            this.getListData()
        },
        groupBy(arr, key) {
            return arr.reduce((groups, item) => {
                const groupKey = item[key]
                groups[groupKey] = groups[groupKey] || []
                groups[groupKey].push(item)
                return groups
            }, {})
        },
        // span-method合并规则
        objectSpanMethod({ row, column, rowIndex }) {
            const spanArr = []
            // 1. 按ID分组当前数据
            const grouped = this.groupBy(this.tableData, 'projectCode')
            // 2. 判断当前列是否属于“需要合并的字段”
            const isMergeCol = this.colSpan.some((col) => col === column.property)

            if (isMergeCol) {
                // 找到当前行所在的分组
                const currentGroup = Object.values(grouped).find((g) => g.includes(row))
                const indexInGroup = currentGroup.indexOf(row)

                // 分组的第一行：合并行数=分组长度；其他行：合并行数=0（被合并）
                if (indexInGroup === 0) {
                    // this.spanArr.push({ rowspan: currentGroup.length, colspan: 1 })
                    return { rowspan: currentGroup.length, colspan: 1 }
                } else {
                    // this.spanArr.push({ rowspan: 0, colspan: 0 })
                    return { rowspan: 0, colspan: 0 }
                }
            } else {
                // 不需要合并的字段：行、列跨度都为1
                // this.spanArr.push({ rowspan: 1, colspan: 1 })
                return { rowspan: 1, colspan: 1 }
            }
        },
        async getListData() {
            // this.loading = true
            let data = {
                pageSize: this.params.pageSize,
                pageNum: this.params.pageNum,
                orderBy: 'projectCode desc',
                searchAndOr: 'or',
                searchMap: {
                    projectCode: this.searchText,
                    flSubject: this.searchText,
                    zbXmbh: this.searchText,
                    projectFzrPhone: this.searchText,
                    projectFzr: this.searchText,
                    projectUnit: this.searchText
                }
            }

            let apiUrl = 'zbgl/zbxmArchView/listdata'
            if (this.$route.meta.params) {
                apiUrl += '?' + this.$route.meta.params
            }

            const res = await this.$app.listdata(apiUrl, data)
            console.log(1111, res)
            //this.loading = false
            this.tableData = res.body.pageInfo.list
            this.processTableData()
            this.total = res.body.pageInfo.total
        },
        toExport() {
            if (!this.rowsSelected.length) {
                this.$confirm('<span>您是否确认要导出当前列表的全部数据?<br/>如果仅需导出部分数据，请先选择或通过搜索筛选。<span>', '确认操作', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                })
                    .then(() => {
                        // listpageViewUrl=znbg.voteResult.list_PHsWFj.vue
                        window.open(`/apigw/cwgl/invoiceApplyProjectItem/exportdata?pageSize=65000&pageNum=1&listpageViewUrl=%2Fcwgl%2FinvoiceApplyProjectItem%2Flist_kGEh9b.html&searchAndOr=&fileName=${this.$route.meta.tagTitle}&httpPort=${location.port}&urlsearch=`)
                    })
                    .catch(() => {
                        // do nothing
                    })
            } else {
                var ids = this.rowsSelected.map((item) => item.id).join(',')
                window.open(`/apigw/cwgl/invoiceApplyProjectItem/exportdata?pageSize=65000&pageNum=1&listpageViewUrl=%2Fcwgl%2FinvoiceApplyProjectItem%2Flist_kGEh9b.html&searchAndOr=&fileName=${this.$route.meta.tagTitle}&httpPort=${location.port}&urlsearch=id:${ids}`)
            }
        },
        changeStatus(row) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: '/zbgl/zbxmArchView/archivedProjectByIds?ids=' + row.id
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.getListData()
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        exportData(row) {
            window.open('/apigw/zbgl/zbxmArchView/downloadProjectAttachmentByIds?ids=' + row.uniqueId)
        },
        // 核心：处理数据（分长度场景）
        processTableData() {
            const finalArr = []
            this.tableData.forEach((mainRow) => {
                // 1. 获取子数组长度（两数组长度一致，取ggfbItems即可）
                const subLen = mainRow.passenger.ggfbItems?.length || 0

                // 2. 场景1：子数组长度=0 → 直接保留原主项
                if (subLen === 0) {
                    finalArr.push({
                        ...mainRow,
                        ggfbItems: [], // 清空子数组，避免冗余
                        jggsfbItems: [],
                        jggdNotifications: []
                    })
                    return
                }

                // 3. 场景2：子数组长度=1 → 融合子项字段到主项
                if (subLen === 1) {
                    const ggfbItem = mainRow.passenger.ggfbItems[0]
                    const jggsfbItem = mainRow.passenger.jggsfbItems[0]
                    const jggdNotifications = mainRow.passenger.jggdNotifications[0]
                    finalArr.push({
                        ...mainRow, // 主项字段
                        ...ggfbItem,
                        ...jggsfbItem,
                        ...jggdNotifications,
                        uniqueId: `${mainRow.id}`, // 可选：给主项加唯一标识（避免ID重复）
                        ggfbItems: [], // 清空子数组
                        jggsfbItems: [],
                        jggdNotifications: []
                    })
                    return
                }

                // 4. 场景3：子数组长度>1 → 复制等量主项，逐个融合对应子项
                if (subLen > 1) {
                    mainRow.passenger.ggfbItems.forEach((ggfbItem, index) => {
                        const jggsfbItem = mainRow.passenger.jggsfbItems[index]
                        const jggdNotifications = mainRow.passenger.jggdNotifications[index]
                        finalArr.push({
                            ...mainRow, // 复制主项字段
                            ...ggfbItem,
                            ...jggsfbItem,
                            ...jggdNotifications,
                            // 可选：给复制的主项加唯一标识（避免ID重复）
                            uniqueId: `${mainRow.id}`,
                            ggfbItems: [],
                            jggsfbItems: [],
                            jggdNotifications: []
                        })
                    })
                }
            })
            this.tableData = finalArr
            this.tableData.forEach((item) => {
                item.jgPublicDate = item.jgPublicDate ? item.jgPublicDate.substring(0, 10) : ''
                item.cgPublicDate = item.cgPublicDate ? item.cgPublicDate.substring(0, 10) : ''
                item.notificationDate = item.notificationDate ? item.notificationDate.substring(0, 10) : ''
                item.contractDate = item.contractDate ? item.contractDate.substring(0, 10) : ''
                item.openBidDate = item.openBidDate ? item.openBidDate.substring(0, 10) : ''
                item.zbWay = this.getWay(item.zbWay)
                item.zbType = this.getType(item.zbType)
                item.ggType = item.ggType == 1 ? '中标/成交' : '流标/终止'
            })
        },
        getType(value) {
            switch (value) {
                case 1:
                    return '工程'
                case 2:
                    return '货物'
                case 3:
                    return '服务'
            }
        },
        getWay(value) {
            switch (value) {
                case 1:
                    return '公开招标'
                case 2:
                    return '邀请招标'
                case 3:
                    return '竞争性谈判'
                case 4:
                    return '单一来源采购'
                case 5:
                    return '询价'
                case 6:
                    return '竞争性磋商'
                case 7:
                    return '框架协议'
                case 9:
                    return '其他'
                default:
                    return ''
            }
        }
        // indexMethod(index) {
        //     //仅第一个合并项显示序号
        //     if (this.spanArr[index].rowspan > 0) {
        //         this.serialNumber++
        //         return this.serialNumber
        //     }
        //     return '' // 隐藏其他项的序号
        // }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-table__fixed {
    background-color: #ffffff !important; /* 容器背景色，避免间隙透传 */
    z-index: 1; /* 层级仅高于主体，不额外上浮 */
}
::v-deep .el-table__fixed .el-table-cell {
    background-color: #ffffff !important; /* 单元格强制白色背景 */
    border-right: 1px solid #ebeef5 !important; /* 补充边框，避免边框处透传 */
}

/* 2. 修复右侧固定列背景透传 */
::v-deep .el-table__fixed-right {
    background-color: #ffffff !important; /* 容器背景色 */
    z-index: 1;
    border-left: 1px solid #ebeef5 !important; /* 补充边框 */
}
::v-deep .el-table__fixed-right .el-table-cell {
    background-color: #ffffff !important; /* 单元格白色背景，核心修复 */
    /* 确保单元格高度铺满，无间隙透传 */
    height: 100% !important;
    line-height: normal !important;
    padding: 12px 0 !important;
}

/* 3. 适配行 hover 状态，避免 hover 时透传 */
::v-deep .el-table__fixed tr:hover .el-table-cell,
::v-deep .el-table__fixed-right tr:hover .el-table-cell {
    background-color: #f2f5fb !important; /* hover 背景色，覆盖透传 */
}

/* 4. 适配行选中状态，避免选中时透传 */
::v-deep .el-table__fixed tr.current-row .el-table-cell,
::v-deep .el-table__fixed-right tr.current-row .el-table-cell {
    background-color: #e8f4ff !important; /* 选中背景色，覆盖透传 */
}

/* 5. 修复固定列与主体的间隙（间隙处透传的重灾区） */
::v-deep .el-table__fixed-right {
    right: 0 !important; /* 消除右侧间隙 */
}
::v-deep .el-table__fixed {
    left: 0 !important; /* 消除左侧间隙 */
}
.advanced-btn {
    display: none !important;
}
</style>
<style>
.hide-advanced-btn {
    display: none !important;
}
/* .advanced-btn{
    display: none !important;
}
.el-breadcrumb__inner .no-redirect{
    display: none !important;
} */
</style>
